import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';
import { Bookafreedemo } from 'src/app/Models/Bookafreedemo';
import { NotificationType } from 'src/app/enum/NotificationType';
import { BookAFreeDemoService } from 'src/app/services/book-afree-demo.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CourceService } from 'src/app/services/cource.service';
import { GradeModel } from 'src/app/Models/GradeModel';
import { AuthService, AuthResponse } from 'src/app/services/auth.service';
import { TurnstileService } from 'src/app/services/turnstile.service';
import { SourceIdEnum } from 'src/app/Models/sourceIdEnumModel';
import { CountryCodeModel } from 'src/app/Models/CountryCode.Model';
import { ClientIPAddressService } from 'src/app/services/client-ipaddress.service';
@Component({
  selector: 'app-free-demo-registration',
  templateUrl: './free-demo-registration.component.html',
  styleUrls: ['./free-demo-registration.component.css', '../../../assets/css/tool.css']
})
export class FreeDemoRegistrationComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('turnstileContainer') turnstileContainer?: ElementRef<HTMLElement>;
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef<HTMLInputElement>>;
  @Input() min: any;
  @Input() UserName!: string;
  @Input() Phone!: string;
  @Input() Email = '';
  @Input() sourceId!: number;
  selectedGrade!: any;
  topic: any;
  isSubmitted = false;
  mobile: any;
  responseMessage!: string;
  forms!: FormGroup;
  otpForm!: FormGroup;
  separateDialCode = true;
  bookFreeDemoData: Bookafreedemo = {};
  submitted = false;
  submitting = false;
  sendingOtp = false;
  verifyingOtp = false;
  otpSubmitted = false;
  showOtpSection = false;
  isEmailOtpVerified = false;
  isVerifiedLoggedInUser = false;
  turnstileLoading = false;
  turnstileToken = '';
  grades: Array<GradeModel> = [];
  private turnstileWidgetId: string | null = null;
  private clientCity = '';
  private clientCountry = '';
  private clientIpLookupPromise?: Promise<void>;
  readonly otpControlNames = ['otp1', 'otp2', 'otp3', 'otp4', 'otp5', 'otp6'];

  constructor(public activeModal: NgbActiveModal,
    public formBuilder: FormBuilder,
    public bookFreeDemo: BookAFreeDemoService,
    private notificationService: NotificationService,
    private courceService: CourceService,
    private authService: AuthService,
    private turnstileService: TurnstileService,
    private clientIPAdressService: ClientIPAddressService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {

  }


  ngOnInit() {
    this.isVerifiedLoggedInUser = this.authService.isAuthenticated();
    const currentUser = this.authService.getUser();

    this.courceService.getAllGrades().subscribe((res) => {
      this.grades = res.sort((x) => x.id).reverse();
    });
    void this.initializeClientIpContext();
    this.forms = this.formBuilder.group(
      {
        name: [this.UserName || currentUser?.name || (currentUser as any)?.Name || '', [Validators.required, Validators.pattern('^[a-zA-Z ]+$')]],
        phoneNumber: [this.Phone || currentUser?.mobileNumber || (currentUser as any)?.mobile || (currentUser as any)?.Mobile || '', [Validators.required, Validators.pattern('^\\+?[0-9 -]{10,18}$')]],
        email: [this.Email || currentUser?.email || (currentUser as any)?.Email || '', [Validators.required, Validators.email]],
        selectedGrade: ['12', Validators.required],
        topic: ['', Validators.required],
        description: ['', [Validators.required, Validators.maxLength(500)]],
      }
    );
    this.otpForm = this.formBuilder.group({
      otp1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp4: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp5: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp6: ['', [Validators.required, Validators.pattern(/^\d$/)]],
    });
  }

  ngAfterViewInit(): void {
    if (!this.isVerifiedLoggedInUser) {
      this.renderTurnstile();
      this.changeDetectorRef.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.resetTurnstile();
  }
  get f() {
    return this.forms.controls;
  }

  closeModal() {
    this.activeModal.close();
  }

  changeGrade(e: any) {
    this.forms.controls['selectedGrade'].setValue(e.target.value, {
      onlySelf: true,
    });
  }

  async onSubmit(): Promise<void> {
    this.submitted = true;

    if (this.submitting || this.sendingOtp || this.verifyingOtp) {
      return;
    }

    const fieldsToValidate = this.isVerifiedLoggedInUser
      ? ['name', 'selectedGrade', 'topic', 'description']
      : ['name', 'phoneNumber', 'email', 'selectedGrade', 'topic', 'description'];
    const hasInvalidFields = fieldsToValidate.some((fieldName) => this.forms.controls[fieldName].invalid);

    if (hasInvalidFields) {
      fieldsToValidate.forEach((fieldName) => this.forms.controls[fieldName].markAsTouched());
      return;
    }

    await this.ensureClientIpContext();
    this.bookFreeDemoData = this.buildDemoPayload();

    if (this.isVerifiedLoggedInUser || this.isEmailOtpVerified) {
      await this.submitDemoRequest();
      return;
    }

    if (!this.showOtpSection) {
      await this.requestOtp();
      return;
    }

    await this.verifyOtpAndSubmit();
  }

  private buildDemoPayload(): Bookafreedemo {
    const currentUser = this.authService.getUser() as any;
    const userId = this.authService.getUserId() ?? currentUser?.id ?? currentUser?.userId ?? currentUser?.UserId;

    return {
      Name: String(this.forms.value.name || currentUser?.name || currentUser?.Name || '').trim(),
      Mobile: String(this.forms.value.phoneNumber || currentUser?.mobileNumber || currentUser?.mobile || currentUser?.Mobile || '').trim(),
      Email: String(this.forms.value.email || currentUser?.email || currentUser?.Email || '').trim(),
      Grade: String(this.forms.value.selectedGrade || '').trim(),
      Topic: String(this.forms.value.topic || '').trim(),
      Description: String(this.forms.value.description || '').trim(),
      userDetails: {
        userId: userId !== null && userId !== undefined && userId !== '' ? Number(userId) : 0,
        grade: String(this.forms.value.selectedGrade || currentUser?.userDetails?.grade || '').trim(),
        country: this.getCountryName(this.forms.value.phoneNumber, currentUser),
        city: String(currentUser?.userDetails?.city || currentUser?.city || this.clientCity || '').trim(),
      },
      ...(userId !== null && userId !== undefined && userId !== '' ? { UserId: Number(userId) } : {}),
      sourceNameId: this.sourceId || SourceIdEnum.FreeDemo,
      registrationUrl: '/BookAFreeDemo',
      userTypeId: 1,
    };
  }

  private getCountryName(phoneNumber: unknown, currentUser: any): string {
    const storedCountry = currentUser?.userDetails?.country || currentUser?.country || currentUser?.Country;
    const dialCode = String(phoneNumber ?? '').split('-')[0].trim();
    return String(
      CountryCodeModel.find((country) => country.code === dialCode)?.country || storedCountry || this.clientCountry || ''
    ).trim();
  }

  private async initializeClientIpContext(): Promise<void> {
    if (!this.clientIpLookupPromise) {
      this.clientIpLookupPromise = (async () => {
        try {
          const data = await firstValueFrom(this.clientIPAdressService.getClientIp());
          this.clientCity = String(data?.response?.city || '').trim();
          this.clientCountry = String(data?.response?.country || '').trim();
        } catch {
          this.clientCity = '';
          this.clientCountry = '';
        }
      })();
    }

    await this.clientIpLookupPromise;
  }

  private async ensureClientIpContext(): Promise<void> {
    await this.initializeClientIpContext();
  }

  private async requestOtp(): Promise<void> {
    if (!this.turnstileToken) {
      this.notificationService.notifyMessage(NotificationType.Warning, 'Please complete the bot verification first.');
      return;
    }

    this.sendingOtp = true;
    try {
      const response = await firstValueFrom(this.authService.sendEmailOtp({
        email: this.bookFreeDemoData.Email || '',
        name: this.bookFreeDemoData.Name,
        mobile: this.bookFreeDemoData.Mobile,
        userTypeId: 1,
        turnstileToken: this.turnstileToken,
        sourceNameId: this.sourceId || SourceIdEnum.FreeDemo,
        registrationUrl: '/BookAFreeDemo',
      }));

      if (!this.isSuccessfulResponse(response)) {
        throw response;
      }

      this.showOtpSection = true;
      this.isEmailOtpVerified = false;
      this.otpSubmitted = false;
      this.otpForm.reset();
      this.resetTurnstile();
      this.notificationService.notifyMessage(NotificationType.Success, response?.message || 'OTP sent to your email address.');
    } catch (error) {
      this.resetTurnstile();
      this.notificationService.notifyMessage(NotificationType.Fail, this.getErrorMessage(error, 'Unable to send OTP. Please try again.'));
    } finally {
      this.sendingOtp = false;
    }
  }

  private async verifyOtpAndSubmit(): Promise<void> {
    this.otpSubmitted = true;
    Object.values(this.otpForm.controls).forEach((control) => control.markAsTouched());
    if (this.otpForm.invalid) {
      return;
    }

    this.verifyingOtp = true;
    try {
      const demoData = this.buildDemoPayload();
      this.bookFreeDemoData = demoData;

      const response = await firstValueFrom(this.authService.verifyEmailOtp({
        email: demoData.Email || '',
        name: demoData.Name,
        mobile: demoData.Mobile,
        otp: this.getOtpValue(),
        userTypeId: 1,
        sourceNameId: this.sourceId || SourceIdEnum.FreeDemo,
        registrationUrl: '/BookAFreeDemo',
      }));

      if (!this.isSuccessfulResponse(response)) {
        throw response;
      }

      this.isEmailOtpVerified = true;
      this.showOtpSection = false;
      await this.submitDemoRequest();
    } catch (error) {
      this.notificationService.notifyMessage(NotificationType.Fail, this.getErrorMessage(error, 'Invalid OTP. Please try again.'));
    } finally {
      this.verifyingOtp = false;
    }
  }

  private getOtpValue(): string {
    return this.otpControlNames
      .map((controlName) => String(this.otpForm.get(controlName)?.value || ''))
      .join('');
  }

  private focusOtpInput(index: number): void {
    this.otpInputs?.get(index)?.nativeElement.focus();
  }

  onOtpInput(index: number, event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = String(input.value || '').replace(/\D/g, '').slice(-1);
    input.value = value;
    this.otpForm.get(this.otpControlNames[index])?.setValue(value);

    if (value && index < this.otpControlNames.length - 1) {
      this.focusOtpInput(index + 1);
    }
  }

  onOtpKeydown(index: number, event: KeyboardEvent): void {
    if (event.key !== 'Backspace') {
      return;
    }

    const control = this.otpForm.get(this.otpControlNames[index]);
    if (!String(control?.value || '').trim() && index > 0) {
      this.focusOtpInput(index - 1);
    }
  }

  onOtpPaste(event: ClipboardEvent): void {
    const digits = String(event.clipboardData?.getData('text') || '')
      .replace(/\D/g, '')
      .slice(0, this.otpControlNames.length);

    if (!digits) {
      return;
    }

    event.preventDefault();
    this.otpControlNames.forEach((controlName, index) => {
      this.otpForm.get(controlName)?.setValue(digits[index] || '');
    });
    this.focusOtpInput(Math.min(digits.length, this.otpControlNames.length) - 1);
  }

  private async submitDemoRequest(): Promise<void> {
    this.submitting = true;
    try {
      const response = await firstValueFrom(this.bookFreeDemo.bookFreeDemo(this.bookFreeDemoData));
      if (!this.isSuccessfulResponse(response)) {
        throw response;
      }

      this.notificationService.notifyMessage(NotificationType.Success, response?.message || 'Demo request submitted successfully.');
      this.forms.reset({ name: '', phoneNumber: '', email: '', selectedGrade: '12', topic: '', description: '' });
      this.submitted = false;
      this.otpSubmitted = false;
      this.activeModal.close();
    } catch (error) {
      this.notificationService.notifyMessage(NotificationType.Fail, this.getErrorMessage(error, 'Unable to submit the demo request. Please try again.'));
    } finally {
      this.submitting = false;
    }
  }

  private isSuccessfulResponse(response: AuthResponse | any): boolean {
    return response?.success === true || response?.isSuccess === true;
  }

  private renderTurnstile(): void {
    if (!this.turnstileContainer) {
      return;
    }

    this.turnstileLoading = true;
    void this.turnstileService.render(this.turnstileContainer.nativeElement, {
      success: (token) => {
        this.turnstileToken = token;
        this.turnstileLoading = false;
      },
      expired: () => {
        this.turnstileToken = '';
        this.turnstileLoading = false;
      },
      error: () => {
        this.turnstileToken = '';
        this.turnstileLoading = false;
        this.notificationService.notifyMessage(NotificationType.Warning, 'Bot verification failed. Please retry.');
      },
    }).then((widgetId) => {
      this.turnstileWidgetId = widgetId;
    }).catch(() => {
      this.turnstileLoading = false;
      this.notificationService.notifyMessage(NotificationType.Warning, 'Bot verification could not load. Please retry.');
    });
  }

  private resetTurnstile(): void {
    this.turnstileToken = '';
    this.turnstileService.reset(this.turnstileWidgetId);
  }

  private getErrorMessage(error: any, fallback: string): string {
    return error?.error?.message || error?.message || fallback;
  }
}
